import script from "./user-notifications-settings.vue?vue&type=script&setup=true&lang=js"
export * from "./user-notifications-settings.vue?vue&type=script&setup=true&lang=js"

import "./user-notifications-settings.vue?vue&type=style&index=0&id=497f8e3c&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-497f8e3c"]])

export default __exports__